import "../plugins/multiselect-dropdown.js";
import "../plugins/custom-select.min.js";

const categoryFilter = document.querySelector(".product-filter__select#categories");
const brandFilter = document.querySelector(".product-filter__select#brands");
const sort = document.querySelector(".orderby");
const loadMoreButton = document.querySelector("#product-load-more .load-more");
let currentSort = "menu_order";
let selectedBrand = [];
let selectedCategory = [];
let currentPage = 1;

if (categoryFilter) {
    categoryFilter.addEventListener("change", (e) => {
        currentPage = 1;
        selectedCategory = [...categoryFilter.options].filter((opt) => opt.selected).map((option) => option.value);
        filterProducts(currentSort);
        populateFilter("brands");
    });

    populateFilter("categories");
}

if (brandFilter) {
    brandFilter.addEventListener("change", (e) => {
        currentPage = 1;
        selectedBrand = [...brandFilter.options].filter((opt) => opt.selected).map((option) => option.value);
        filterProducts(currentSort);
        populateFilter("categories");
    });

    populateFilter("brands");
}
if (sort) {
    customSelect(sort);
    sort.customSelect.select.addEventListener("change", (e) => {
        currentPage = 1;
        filterProducts(e.srcElement.value);
        currentSort = e.srcElement.value;
    });
}

if (loadMoreButton) {
    loadMoreButton.addEventListener("click", () => {
        currentPage++;
        filterProducts(currentSort, currentPage);
    });
}

if (categoryFilter || brandFilter || sort || loadMoreButton) {
    filterProducts(currentSort);
}

addToCartAnimationListener();

function filterProducts(sort, page = 1) {
    const form = new FormData(document.querySelector("form.product-filter"));
    form.append("action", "nobox_get_products");
    form.append("sort", sort);
    form.append("page", page);
    const params = new URLSearchParams(form);

    fetch(horizon.ajaxUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Cache-Control": "no-cache",
        },
        body: params,
    })
        .then((response) => response.json())
        .then((data) => {
            const prodContainer = document.querySelector("ul.products");
            if (page === 1 && prodContainer) {
                prodContainer.innerHTML = "";
            }

            prodContainer.insertAdjacentHTML("beforeend", createElementFromHTML(data.html).innerHTML);

            if (data.count <= prodContainer.children.length) {
                document.querySelector("button.load-more").classList.add("load-more--hidden");
            } else {
                document.querySelector("button.load-more").classList.remove("load-more--hidden");
            }

            updateCounter(page, data.count);
            addToCartAnimationListener();
        });
}

function populateFilter(type) {
    const form = new FormData(document.querySelector("form.product-filter"));
    form.append("action", "nobox_woo_get_" + type);
    const params = new URLSearchParams(form);

    const select = document.querySelector("select#" + type);

    fetch(horizon.ajaxUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Cache-Control": "no-cache",
        },
        body: params,
    })
        .then((response) => response.json())
        .then((data) => {
            select.innerHTML = "";

            if (data) {
                Array.from(data)
                    .sort((a, b) => b.count - a.count)
                    .forEach((item) => {
                        select.innerHTML += `<option value="${item.term_id}" class="${item.count === 0 ? "empty" : ""}" ${getSelected(item.term_id, item.taxonomy)}>${item.name} (${item.count})</option>`;
                    });

                if (typeof select.loadOptions !== "undefined") {
                    select.loadOptions();
                }
            }
        });
}

function getSelected(term_id, type) {
    let selected = "";

    if (type === "product_cat" && selectedCategory && selectedCategory.includes(term_id.toString())) {
        selected = "selected";
    } else if (type === "product_brand" && selectedBrand && selectedBrand.includes(term_id.toString())) {
        selected = "selected";
    }

    return selected;
}

function createElementFromHTML(htmlString) {
    var div = document.createElement("div");
    div.innerHTML = htmlString.trim();

    return div.firstChild;
}

function updateCounter(page, total) {
    const counter = document.querySelector(".woocommerce-result-count strong");
    counter.textContent = `Visar 1 - ${document.querySelector("ul.products").children.length} av ${total} resultat`;
}

export function addToCartAnimationListener() {
    const add_to_cart = document.querySelectorAll(".ajax_add_to_cart");
    if (add_to_cart) {
        const cart = document.querySelector("#cart-icon");
        const cart_number = document.querySelector("#cart-number");
        add_to_cart.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                cart.classList.add("cart-icon--added");
                cart_number.textContent = parseInt(cart_number.textContent) + 1;
                btn.innerHTML = '<i class="far fa-check"></i>';

                setTimeout(() => {
                    cart.classList.remove("cart-icon--added");
                    btn.innerHTML = "Köp";
                }, 2000);
            });
        });
    }
}
